export var TouchEventType = {
    UNDETERMINED: 0,
    TOUCHES_DOWN: 1,
    TOUCHES_MOVE: 2,
    TOUCHES_UP: 3,
    TOUCHES_CANCELLED: 4
};
